

























































import { Component, Vue } from 'vue-property-decorator';

import ChipView from './components/Chipview.vue';
import PeripheryList from './components/PeripheryList.vue'
import ProjectSettingsView from './components/ProjectSettingsView.vue';
import PeripheryProperties from './components/properties/PeripheryProperties.vue';
import ClockView from './components/Clockview.vue';

import Tabs from './components/standart/Tabs.vue';
import VueStrong from '@/vueStrong';
import { ProjectActions, ProjectMutations } from './store/types';
import axios from 'axios';

import introJs, { Step } from 'intro.js';
import { createIntro } from './shared/helpers';

@Component({
  components: {
    ClockView,
    ChipView,
    PeripheryList,
    PeripheryProperties,
    Tabs,
    ProjectSettingsView,
  },
})
export default class App extends VueStrong {
  welcomeTourSteps: Step[] = [
    {
      element: '#step-init',
      title: 'Добро пожаловать',
      intro: `Откройте возможности конфигуратора MIK32 прямо сейчас!`
    },
    {
      element: '#step-new',
      title: 'Новый',
      intro: `Создать пустой проект (внимание - при сохранении в LocalStorage вы удалите старый)`
    },
    {
      element: '#step-file',
      title: 'Файл',
      intro: `Опция пока недоступна, в дальнейшем планируется запись и чтение проекта настроек из файла`
    },
    {
      element: '#step-local',
      title: 'Из локального хранилища',
      intro: `Загрузить проект из LocalStorage (не очищайте куки и прочие файлы браузера чтобы не потерять данные)`
    },
  ];

  mounted():void {
    axios.interceptors.request.use((config) => {
      // spinning start to show
      this.$store.commit(ProjectMutations.SET_IS_LOADING, true);

      return config;
    }, function (error) {
      return Promise.reject(error);
    });

    axios.interceptors.response.use((response) => {
      this.$store.commit(ProjectMutations.SET_IS_LOADING, false);

      return response;
    }, function (error) {
      return Promise.reject(error);
    });

    this.$store.dispatch(ProjectActions.LOAD_GITHUB);

    if (window.localStorage.getItem('uzhe_smesharik') !== '1') {
      createIntro().setOptions({
        steps: this.welcomeTourSteps,
      }).start().oncomplete(()=>{
        window.localStorage.setItem('uzhe_smesharik', '1');
      });
    }
  }

  loadFromSketch(): void {
    this.$store.dispatch(ProjectActions.LOAD_PROJECT, 'empty');
  }

  loadFromLocalStorage(): void {
    this.$store.dispatch(ProjectActions.LOAD_PROJECT, 'localstorage');
  }

  get isProjectLoaded(): boolean {
    return this.$store.state.isProjectLoaded;
  }
  
  get isLoading(): boolean {
    return this.$store.state.isLoading;
  }

  get errors(): Error[] {
    return this.$store.state.errors;
  }

  get hasLocalStorage(): boolean {
    return window.localStorage.getItem('project') !== null;
  }
}
